import { render, staticRenderFns } from "./OtherCardList.vue?vue&type=template&id=2e0b2d56&"
import script from "./OtherCardList.vue?vue&type=script&lang=js&"
export * from "./OtherCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports